var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"field-label",class:{ 'field-label--has-icon': Boolean(_vm.$attrs.icon) }},[_c('label',{staticClass:"elder-input__label",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('span',{staticClass:"field-label__icon"},[(_vm.$attrs.icon)?_c('Icon',{attrs:{"icon":_vm.$attrs.icon,"size":"1x"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }